import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import Contact from '@/components/Contact/Contact';
import Game from '@/components/Game/Game';
import Replay from '@/components/Replay/Replay';
import Home from '@/components/Home/Home';
import Leaderboard from '@/components/Leaderboard/Leaderboard';
import Matches from '@/components/Matches/Matches';
import RecentMatches from '@/components/RecentMatches/RecentMatches';
import Login from '@/components/Login/Login';
import PasswordReset from '@/components/PasswordReset/PasswordReset';
import Profile from '@/components/Profile/Profile';
import RoomList from '@/components/RoomList/RoomList';
import Rules from '@/components/Rules/Rules';
import Users from '@/components/Users/Users';
import Cards from '@/components/Cards/Cards';

const history = process.env.NODE_ENV === 'production'
    ? createWebHistory()
    : createWebHashHistory();

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/how-to-play/:scrollTo?',
        name: 'how-to-play',
        component: Rules,
    },
    {
        path: '/login/:action?/:redirect?',
        name: 'login',
        component: Login,
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
    },
    {
        path: '/game/:id/replay/:redirect?',
        name: 'replay',
        component: Replay,
    },
    {
        path: '/game/:id/:redirect?',
        name: 'game',
        component: Game,
    },
    {
        path: '/rooms/:tab?',
        name: 'rooms',
        component: RoomList,
    },
    {
        path: '/contact-us',
        name: 'contact',
        component: Contact,
    },
    {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset,
    },
    {
        path: '/leaderboard',
        name: 'leaderboard',
        component: Leaderboard,
    },
    {
        path: '/matches/:username?',
        name: 'matches',
        component: Matches,
    },
    {
        path: '/recent-matches',
        name: 'recent-matches',
        component: RecentMatches,
    },
    {
        path: '/users',
        name: 'users',
        component: Users,
    },
    {
        path: '/cards',
        name: 'cards',
        component: Cards,
    },
];

const router = createRouter({
    history,
    routes,
});

export default router;
